import React from "react";

export default function Error() {
  return <div>404 error</div>;
}



// WEBPACK FOOTER //
// ./src/pages/Error.js